import { Component, OnInit, ElementRef, AfterViewInit, ViewChild, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { fadeIfAnimation, ifHeightAnimation } from '@app/animations';
import { PageParams, ParamsType } from '@app/constants';
import { Router, ActivatedRoute } from '@angular/router';
import { fromEvent, Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, tap, mergeMap, map } from 'rxjs/operators';
import { DataService, PlatformService } from '@app/data';

@Component({
  selector: 'app-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.less'],
  animations: [fadeIfAnimation, ifHeightAnimation]
})
export class InputComponent implements AfterViewInit {

  @ViewChild('input', {read: ElementRef}) input!: ElementRef;
  @Input() pageParams$!: Observable<PageParams>;
  @Input() queryParams!: ParamsType;

  public showReset$ = new BehaviorSubject<boolean>(false);
  public error$ = new BehaviorSubject<boolean>(false);
  public strategy = this.platform.isBrowser ? 'local' : 'global';

  constructor(
    private data: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private platform: PlatformService
  ) {}

  ngAfterViewInit(): void {
    this.checkLength();
  }

  public onSubmit = (input: string) => {
    //console.log('**** InputComponent onSubmit **** input ', input);

    if (input.length >= 3) {
      this.error$.next(false);
      this.router.navigate(['./'], {queryParams: {text:  input}, queryParamsHandling: 'merge', relativeTo: this.route});
    }
    else {
      this.error$.next(true);
    }
  }

  public submit = (event: Event) => {
    console.log('**** InputComponent onSubmit **** event ', event);
    const input = this.input.nativeElement.value;

    if (input.length >= 3) {
      this.error$.next(false);
      this.router.navigate(['./'], {queryParams: {text:  input}, queryParamsHandling: 'merge', relativeTo: this.route});
    }
    else {
      this.error$.next(true);
    }
  }

  public resetText = (event: Event):void => {
    //console.log('**** InputComponent resetText ****  ');

    let params = { ...this.queryParams || {}};

    if (params.text) {
      delete params.text;
    }

    this.router.navigate(['./'], {queryParams: params, queryParamsHandling: '', relativeTo: this.route});
    this.input.nativeElement.value = '';
  }

  public onBlur = (event: Event) => {
    console.log('**** InputComponent onBlur **** event ', event);
  }

  public onFocus = (event: Event) => {
    console.log('**** InputComponent onFocus **** event ', event);
  }

  public onInput = (event: Event) => {
    console.log('**** InputComponent onInput **** event ', event);
    this.checkLength();
  }

  private checkLength = (): void => {
    const text = this.input.nativeElement.value;

    if (text.length >= 3) {
      this.showReset$.next(true);
      this.error$.next(false);
    }
  }
}
